export const URLs = {
  SLACK_NEW_ACCOUNT: '/accounts/slack/new',
  AWS_NEW_ACCOUNT: '/accounts/aws/user/new',
};
